import { render, staticRenderFns } from "./TravelRequestApproval.vue?vue&type=template&id=c94c4b0e&"
import script from "./TravelRequestApproval.vue?vue&type=script&lang=js&"
export * from "./TravelRequestApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports